import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fiftyzeroseaterbusonrentpune() {



const cardData =
{
  keyword: '50 Seater Bus on Rent Pune',
  heading: 'Sanavi Travels: 50 Seater Bus on Rent Pune',
  headingDescription: 'Sanavi Travels offers dependable, spacious, and highly professional 50 Seater Bus on Rent Pune services, ideal for large group transportation across Pune and outstation destinations. Pune is a major center for corporate offices, educational institutions, weddings, religious tours, tourist groups, and large social gatherings, making high-capacity bus travel essential for smooth coordination and cost-effective transport. Our 50 seater bus rental service in Pune is perfectly suited for corporate events, employee transportation, school and college trips, wedding guest movement, family functions, group picnics, sightseeing tours, and long-distance outstation journeys. We provide well-maintained AC and Non-AC 50 seater buses with comfortable seating, wide aisles, strong suspension, sufficient legroom, overhead storage, and large luggage space to accommodate group travel comfortably. Every bus is regularly serviced, thoroughly cleaned, and safety-checked before departure to ensure a secure and reliable journey. Our experienced drivers are skilled in handling large vehicles on city roads, highways, ghats, and long routes, ensuring punctual arrivals, smooth driving, and stress-free travel. With transparent pricing, flexible rental packages, customizable routes, and responsive customer support, Sanavi Travels delivers a comfortable, organized, and economical 50 seater bus hire experience in Pune for every travel requirement.',

  top: 'Popular Travel Uses for 50 Seater Bus on Rent Pune',

  "topPlaces": [
    {
      "title": "Corporate & Employee Transportation",
      "description": "50 seater buses are widely used by corporate offices and industries in Pune for employee transportation, office outings, conferences, and offsite meetings. A single large-capacity bus allows companies to transport employees together, maintain punctual schedules, reduce coordination issues, and ensure safe, comfortable travel for staff members on both city and outstation routes."
    },
    {
      "title": "Wedding Guest Transportation",
      "description": "Wedding events in Pune often involve transporting large numbers of guests between homes, hotels, marriage halls, and destination venues. Hiring a 50 seater bus ensures all guests travel together comfortably, arrive on time, and avoid parking and traffic hassles, making wedding logistics smooth and well-organized."
    },
    {
      "title": "School & College Educational Trips",
      "description": "Educational institutions prefer 50 seater buses for school picnics, college excursions, industrial visits, and educational tours. These buses offer safe seating, controlled group travel, and efficient supervision, ensuring students and teachers travel together securely and comfortably."
    },
    {
      "title": "Tourist Group & Sightseeing Travel",
      "description": "Tourist groups visiting Pune and nearby destinations such as Lonavala, Mahabaleshwar, Shirdi, Pandharpur, and Konkan regions often choose 50 seater buses. Large group travel becomes economical, coordinated, and comfortable with ample seating and luggage space."
    },
    {
      "title": "Family Functions & Social Events",
      "description": "Large family gatherings, religious functions, anniversaries, and community events require reliable group transport. A 50 seater bus allows relatives and guests to travel together, enhancing bonding and reducing travel stress."
    },
    {
      "title": "Picnic & Leisure Outings",
      "description": "For company picnics, school outings, and social group leisure trips, 50 seater buses offer a relaxed and enjoyable journey. Groups can travel together, enjoy the ride, and reach picnic destinations without worrying about driving or navigation."
    },
    {
      "title": "Outstation Group Travel",
      "description": "50 seater buses are ideal for long-distance outstation travel from Pune to cities like Mumbai, Goa, Nashik, Kolhapur, Aurangabad, and Solapur. Spacious seating, luggage capacity, and professional drivers ensure comfortable and safe journeys."
    },
    {
      "title": "Religious & Pilgrimage Tours",
      "description": "Pilgrimage tours to Shirdi, Bhimashankar, Jejuri, Ashtavinayak temples, and Pandharpur often involve large groups of devotees. A 50 seater bus allows disciplined, peaceful, and well-coordinated travel for religious journeys."
    },
    {
      "title": "Corporate Training & Seminars",
      "description": "Companies organizing training programs, seminars, and workshops prefer 50 seater buses for transporting participants together, ensuring timely arrivals and professional travel arrangements."
    },
    {
      "title": "Stress-Free Large Group Coordination",
      "description": "Traveling in a single 50 seater bus eliminates the need for multiple vehicles, reduces communication gaps, and ensures the entire group reaches the destination together, making large-group travel smooth and efficient."
    }
  ],

  "services": [
    {
      "name": "50 Seater Bus on Rent Pune",
      "description": "Sanavi Travels provides reliable 50 seater bus rental services in Pune for corporate events, weddings, educational trips, tourist travel, and outstation journeys. Our buses are spacious, clean, and well-maintained, offering comfortable seating, ample luggage space, and safe travel for large groups. With experienced drivers and organized travel planning, we ensure smooth, punctual, and stress-free group transportation."
    },
    {
      "name": "AC 50 Seater Bus Pune",
      "description": "AC 50 seater buses are ideal for long-distance travel, summer journeys, and premium group tours. Air-conditioned interiors provide a cool, comfortable environment, reducing fatigue and enhancing the overall travel experience for passengers."
    },
    {
      "name": "Non AC 50 Seater Bus Hire Pune",
      "description": "Non AC 50 seater buses offer a cost-effective solution for budget-conscious group travel while maintaining safety and seating comfort, suitable for short trips, local travel, and daytime journeys."
    },
    {
      "name": "Luxury 50 Seater Bus Hire Pune",
      "description": "Luxury 50 seater buses feature upgraded interiors, comfortable pushback seats, and enhanced ride quality, making them suitable for corporate functions, VIP transport, destination weddings, and premium tourist travel."
    },
    {
      "name": "50 Seater Bus for Corporate Pune",
      "description": "Corporate 50 seater bus services support employee transportation, conferences, seminars, training programs, and office outings, ensuring punctual and professional group travel."
    },
    {
      "name": "50 Seater Bus for Family Pune",
      "description": "Large families traveling together for functions, vacations, or religious tours prefer 50 seater buses for safety, comfort, and shared travel experiences across all age groups."
    },
    {
      "name": "50 Seater Bus for Wedding Pune",
      "description": "Wedding guest transportation using 50 seater buses helps manage large crowds efficiently, ensuring guests reach venues together comfortably and on time."
    },
    {
      "name": "50 Seater Bus for Picnic Pune",
      "description": "For picnics and leisure outings, 50 seater buses provide relaxed and enjoyable group travel, allowing everyone to focus on fun rather than driving logistics."
    },
    {
      "name": "50 Seater Bus for Tour Pune",
      "description": "Tour groups traveling within Pune or to nearby destinations benefit from 50 seater buses due to ample seating, luggage capacity, and coordinated travel."
    },
    {
      "name": "50 Seater Bus for Outstation Pune",
      "description": "Outstation 50 seater bus services ensure safe, comfortable, and reliable long-distance travel with experienced drivers, planned stops, and smooth highway driving."
    }
  ],

  "tableData": [
    ["50 Seater Bus Hire Pune", "AC 50 Seater Bus"],
    ["Non AC 50 Seater Bus", "Luxury 50 Seater Bus"],
    ["Corporate Travel", "Wedding Transport"],
    ["School & College Trips", "Picnic Travel"],
    ["Tour Groups", "Outstation Travel"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "High Capacity & Spacious Seating",
      "WhyChoosedescription": "50 seater buses comfortably accommodate large groups with ample space and seating comfort."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Professional drivers trained to handle large buses on city roads and highways."
    },
    {
      "WhyChooseheading": "Well-Maintained Fleet",
      "WhyChoosedescription": "All buses are regularly serviced and safety-checked before every trip."
    },
    {
      "WhyChooseheading": "Ideal for Large Groups",
      "WhyChoosedescription": "Perfect solution for corporate events, weddings, tours, and educational trips."
    },
    {
      "WhyChooseheading": "Flexible Rental Packages",
      "WhyChoosedescription": "Customized pricing and travel plans based on distance and duration."
    },
    {
      "WhyChooseheading": "Transparent Pricing",
      "WhyChoosedescription": "Clear and upfront costs with no hidden charges."
    },
    {
      "WhyChooseheading": "Safe & Reliable Travel",
      "WhyChoosedescription": "Focus on passenger safety, punctuality, and smooth journeys."
    },
    {
      "WhyChooseheading": "Trusted Service Provider",
      "WhyChoosedescription": "Sanavi Travels is known for dependable large-group transportation in Pune."
    }
  ]
};

const faqData = [
  { question: 'Do you provide 50 seater bus on rent in Pune?', answer: 'Yes, Sanavi Travels offers reliable 50 seater bus rental services in Pune.' },
  { question: 'Are AC and Non AC 50 seater buses available?', answer: 'Yes, both AC and Non AC options are available depending on your requirement.' },
  { question: 'Is a driver included with the 50 seater bus hire?', answer: 'Yes, all bus rentals include experienced and professional drivers.' },
  { question: 'Can 50 seater buses be hired for weddings?', answer: 'Yes, they are commonly used for wedding guest transportation.' },
  { question: 'Are 50 seater buses suitable for corporate travel?', answer: 'Yes, they are ideal for corporate events, office outings, and employee transport.' },
  { question: 'Is 50 seater bus hire suitable for outstation travel?', answer: 'Yes, our buses are well-equipped for long-distance outstation journeys.' },
  { question: 'Do you provide buses for school and college trips?', answer: 'Yes, 50 seater buses are frequently used for educational tours and excursions.' },
  { question: 'Is advance booking required?', answer: 'Advance booking is recommended, especially during peak seasons.' },
  { question: 'Are the buses regularly maintained?', answer: 'Yes, all buses undergo regular servicing and safety checks.' },
  { question: 'Can the travel route be customized?', answer: 'Yes, routes and schedules can be customized based on your travel plan.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Pawar',
    feedback: 'We hired a 50 seater bus from Sanavi Travels for our corporate event. Excellent service and very comfortable journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rutuja Shinde',
    feedback: 'Our wedding guest transportation was perfectly managed with a 50 seater bus. Highly reliable service.',
    rating: 5
  }
];















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus on Rent Pune - Sanavi Travels",
  "description": "Sanavi Travels offers 50-seater buses on rent in Pune for family trips, corporate travel, group tours, weddings, picnics, outstation trips, and tours. AC and Non-AC 50-seater buses and mini buses are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};






  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | 50 Seater Bus on Rent Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 50-seater buses on rent in Pune with Sanavi Travels. AC & Non-AC 50-seater buses and mini buses for family trips, corporate travel, group tours, weddings, picnics, outstation trips, and tours with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/279.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fiftyzeroseaterbusonrentpune;